import React from 'react';
type SectionHeadingProps = {
  kanji?: string;
  title: string;
  description?: string;
  id?: string;
};
export function SectionHeading({
  kanji,
  title,
  description,
  id
}: SectionHeadingProps) {
  return <div className="max-w-2xl" data-id="element-93" data-mp="3f1vmfia2kffi">
      <div className="flex items-baseline gap-4" data-id="element-94" data-mp="3f2n7hz61iurj">
        {kanji && <span aria-hidden className="font-jp text-3xl text-crimson lg:text-4xl" data-id="element-95" data-mp="3k187bxhdrcfg">
            {kanji}
          </span>}
        <h2 id={id} className="font-display text-2xl font-semibold uppercase tracking-[0.08em] text-bone lg:text-3xl" data-id="element-96" data-mp="bl5bcozmrc6y">
          {title}
        </h2>
      </div>
      {description && <p className="mt-4 text-sm leading-relaxed text-muted lg:text-base" data-id="element-97" data-mp="1tip7xlr7spf">{description}</p>}
    </div>;
}